"use client";
import Link from "next/link";

import LogoIcon from "@/assets/images/logonew.svg?react";
// import LogoIconBordered from "@/assets/images/logo-icon-bordered.svg";
// import LogoText from "@/assets/images/logo-text.svg";

import { cn } from "@/lib/utils";
import { useParams } from "next/navigation";
import { resolveLocale } from "@/lib/resolvedLocale";

export default function Logo({
  wrapperClassName,

  inBackground = false,
}: {
  wrapperClassName?: string;

  inBackground?: boolean;
}) {
  const { locale } = useParams();
  const isRtl = resolveLocale(locale as string | undefined) === "ar";

  if (isRtl) {
    return (
      <span
        className={cn(
          "inline-flex relative gap-x-2 items-center h-10 lg:h-14",
          wrapperClassName,
        )}
      >
        {/* {isBordered ? (
          <LogoIconBordered
            className={cn(
              inBackground ? "logo-with-background" : "logo-primary"
            )}
          />
        ) : (
          <LogoIcon
            className={cn(
              inBackground ? "logo-with-background" : "logo-primary"
            )}
          />
        )}
        <LogoText
          className={cn(inBackground ? "logo-with-background" : "logo-primary")}
        /> */}
        {/* <span className="uppercase font-bold text-xl">App Logo</span> */}

        <LogoIcon
          className={cn(
            inBackground ? "logo-with-background" : "logo-primary",
            "w-full h-full",
          )}
        />
        <Link
          href="/"
          className="font-bold text-xl absolute inset-0 z-10"
        ></Link>
      </span>
    );
  }

  return (
    <span
      className={cn(
        "inline-flex relative gap-x-2 items-center h-10 lg:h-14",
        wrapperClassName,
      )}
    >
      {/* {isBordered ? (
        <LogoIconBordered
          className={cn(inBackground ? "logo-with-background" : "logo-primary")}
        />
      ) : (
        <LogoIcon
          className={cn(inBackground ? "logo-with-background" : "logo-primary")}
        />
      )}

      <LogoText
        className={cn(inBackground ? "logo-with-background" : "logo-primary")}
      /> */}

      <LogoIcon
        className={cn(
          inBackground ? "logo-with-background" : "logo-primary",
          "w-full h-full",
        )}
      />
      {/* <span className="uppercase font-bold text-xl">App Logo</span> */}

      <Link href="/" className="font-bold text-xl absolute inset-0 z-10"></Link>
    </span>
  );
}
